//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class PricingService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[Pricing.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/pricing/create', params || { });
	};

	//GeneratorFlag:[Pricing.Delete]
	async delete(pricingId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:pricingId
		}
	
		return await _server.delete('/store/pricing/delete', {'params':params})
	};

	//GeneratorFlag:[Pricing.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/pricing/detail', {'params':params});
	};

	//GeneratorFlag:[Pricing.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/pricing/list', {'params':params});
	};

	//GeneratorFlag:[Pricing.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/pricing/update', params || { });
	};

//GeneratorFlag:[NewAction]
}